import { css } from '@emotion/core'
import { colors } from '../../../../assets/styles/colors'

export const weekDay = css`
  font-weight: 500;
  padding: 5px;
  border-bottom: 1px solid ${colors.gray7};
  color: ${colors.gray3};
`
